<template>
  <div>
    <el-dialog :title="$t('cartao-postagem')" :visible.sync="dialogFormVisible">
      <el-form :model="formCardPost">
        <el-form-item :label="$t('contrato')" prop="contract">
          <ContractList v-model="formCardPost.contract" :current="formCardPost.contract" />
        </el-form-item>
        <el-form-item :label="$t('cartao-postagem')" prop="cardpost">
          <el-select v-model="formCardPost.cardpost">
            <el-option v-for="record in contracts" :key="record.id" :label="record.code" :value="record.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('tipo')" prop="type">
          <el-select v-model="formCardPost.type">
            <el-option :key="1" label="Contrato" :value="1"> </el-option>
            <!--el-option :key="2" label="Serviço" :value="2"> </el-option-->
          </el-select>
        </el-form-item>
        <el-form-item v-show="formCardPost.type == 2" label="Percentual" prop="value">
          <el-input type="number" max="100" min="1" v-model="formCardPost.value"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="formCardPost.principal">Cartão de postagem principal</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="addCardPost()">Salvar</el-button>
      </span>
    </el-dialog>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-novo-cliente')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-cliente')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" style="display: flex; flex-direction: column; gap: 30px;">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6" :md="6" :lg="4" :xl="4">
            <el-form-item :label="$t('nome-fantasia')" prop="name">
              <el-input ref="name" v-model="ruleForm.name" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="18" :md="18" :lg="10" :xl="10">
            <el-form-item :label="$t('razao-social')" prop="companyname">
              <el-input ref="companyname" v-model="ruleForm.companyname" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
            <el-form-item :label="$t('cpf/cnpj')" prop="federalid" class="is-required">
              <el-input
                v-model="ruleForm.federalid"
                v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"
                @blur="checkFederalidDuplicate"
              ></el-input>
              <div v-if="federalidDuplicate" class="federalid-duplicate">
                CPF/CNPJ já cadastrado! Será um cadastro duplicado.
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
            <el-form-item label="Tipo Cliente" prop="customerType">
              <el-select v-model="ruleForm.customerType">
                <el-option key="1" label="Cliente" value="1" />
                <el-option v-if="user.type === '1'" key="2" label="Licença" value="2" />
                <el-option key="3" label="Filial" value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="8" v-show="ruleForm.customerType === '3'">
            <el-form-item label="Cliente Matriz" prop="headoffice">
              <CustomerList
                :multiple="false"
                ref="headoffice"
                v-model="ruleForm.headoffice"
                :customerType="1"
                :current="ruleForm.headoffice ? [ruleForm.headoffice] : []"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-tabs v-model="activeTab">
          <el-tab-pane :label="$t('faturamento')" name="billet">
            <el-row :gutter="5">
              <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="8">
                <el-form-item :label="$t('tipo-faturamento')" prop="financialtype">
                  <FinancialTypeList v-model="ruleForm.financialtype" :current="ruleForm.financialtype" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="8">
                <el-form-item label="E-mail Financeiro" prop="mail">
                  <el-input ref="mail" v-model="ruleForm.mail" maxlength="80"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="4" :xl="4">
                <el-form-item label="Dias a vencer" prop="day">
                  <el-input ref="day" v-model="ruleForm.day" type="number"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="8">
                <el-form-item label="Beneficiário" prop="name">
                  <BankList v-model="ruleForm.bank" :current="ruleForm.bank" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane :label="$t('endereco')" name="address">
            <CustomerTableAddress
              ref="customerAddress"
              :tableData="addressList"
              @add="addressAdd"
              @update="addressUpdate"
              @remove="addressRemove"
            />
          </el-tab-pane>
          <el-tab-pane label="Contratos" name="contract">
            <el-row :gutter="5">
              <el-col :xs="24">
                <el-form-item :label="$t('tabela-pacote')" prop="packageTable">
                  <PackageTableList v-model="ruleForm.packageTable" :current="ruleForm.packageTable" />
                </el-form-item>
              </el-col>
              <el-col :xs="24">
                <el-form-item :label="$t('tabela-pacote-reversa')" prop="packageTable">
                  <PackageTableList v-model="ruleForm.packageTableReverse" :current="ruleForm.packageTableReverse" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-divider content-position="left"
                  ><el-button type="primary" @click="addpost()" icon="el-icon-plus"></el-button>&nbsp;
                  {{ $t("cartao-postagem") }}
                </el-divider>
                <el-table
                  :data="listCardPost"
                  stripe
                  ref="tableCardPost"
                  style="width: 100%"
                  :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                  <el-table-column width="80">
                    <template slot-scope="scope">
                      <el-button
                        type="danger"
                        @click="delCardPost(scope.row.cardpost.code)"
                        icon="el-icon-delete"
                      ></el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="contract" :label="$t('contrato')">
                    <template slot-scope="scope">
                      {{ scope.row.cardpost.contract.contractid }} -
                      {{ scope.row.cardpost.contract.name }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="code" :label="$t('cartao-postagem')">
                    <template slot-scope="scope">
                      {{ scope.row.cardpost.code }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('tipo')">
                    <template slot-scope="scope">
                      {{ scope.row.type == 1 ? "Contrato" : "Serviço" }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="value" :label="`${$t('valor')}?`"></el-table-column>
                  <el-table-column prop="principal" :label="$t('principal')">
                    <template slot-scope="scope">
                      {{ scope.row.principal ? "Sim" : "Não" }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                <el-form-item :label="$t('cnpj-faturamento')" prop="cnpj" class="is-required">
                  <el-input v-model="ruleForm.federalidPayment" v-mask="'NN.NNN.NNN/NNNN-##'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="16" :lg="12" :xl="12" v-if="user.type === '1'">
                <el-form-item :label="`Valor Seguro Cobrado ( ${'' + ruleForm.insurance}%)`" prop="insurance">
                  <el-slider
                    style="margin-left: 10px; width: 120px"
                    v-model="ruleForm.insurance"
                    :min="1"
                    :max="2"
                    :value="+ruleForm.insurance"
                    :step="0.1"
                    :label="'' + ruleForm.insurance"
                  ></el-slider>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="12" :md="8" :lg="4" :xl="4">
                <el-form-item label="Dias Validade Reversa" prop="daysValidateReverse">
                  <el-input
                    type="number"
                    style="width: 80px"
                    pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$"
                    :max="90"
                    :precision="0"
                    :min="1"
                    v-model="ruleForm.daysValidateReverse"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="4" :xl="4">
                <el-form-item :label="$t('limite-credito')" prop="limit">
                  <CustomerLimit :limit="ruleForm.limit" ref="limit" @save="saveLimit" />
                  <el-input type="text" v-model="ruleForm.limit" disabled>
                    <template slot="append">
                      <el-button type="info" @click="manager">Gerenciar</el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-show="ruleForm.customerType === '3'">
                <el-form-item label="Gerar um boleto separado para essa filial" prop="billetExclusive">
                  <el-switch v-model="ruleForm.billetExclusive"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item label="Não cobrar custo de postagem" prop="calculatePricetable">
                  <el-switch v-model="ruleForm.calculatePricetable"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="user.type === '1'">
                <el-form-item label="Permitir uso etiquetas logicas" prop="useReserve">
                  <el-switch v-model="ruleForm.useReserve"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="payment.display">
              <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4">
                <el-form-item prop="payment">
                  <el-checkbox v-model="ruleForm.payment">{{ $t("usar-meio-pagamento") }}</el-checkbox>
                </el-form-item>
                <el-form-item label="Métodos de pagamento" v-if="ruleForm.payment">
                  <el-checkbox v-show="payment.billet" v-model="ruleForm.recipients.billet">{{
                    $t("boleto")
                  }}</el-checkbox>
                  <el-checkbox v-show="payment.credit" v-model="ruleForm.recipients.credit">{{
                    $t("cartao-credito")
                  }}</el-checkbox>
                  <el-checkbox v-show="payment.debit" v-model="ruleForm.recipients.debit">{{
                    $t("cartao-debito")
                  }}</el-checkbox>
                  <el-checkbox v-show="payment.pix" v-model="ruleForm.recipients.pix">{{ $t("pix") }}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="Serviços" name="services">
            <CustomerTableServices ref="tableServices" :data="ruleForm.service" :id="id" />
          </el-tab-pane>
          <el-tab-pane label="Dados" name="data">
            <el-form-item :label="$t('inscricao-estadual')" prop="cep">
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-input maxlength="20" v-model="ruleForm.registerstate"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('inscricao-municipal')" prop="cep">
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-input maxlength="20" v-model="ruleForm.registermunicipal"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item prop="whatsapp">
              <el-checkbox v-model="ruleForm.whatsapp">Habilitar notificações via Whatsapp</el-checkbox>
              <el-checkbox v-if="user.type === '1'" v-model="ruleForm.unifiedLabel">
                Usar etiqueta unificada DANFE/DC-e
              </el-checkbox>
              <el-checkbox v-if="user.type === '1'" v-model="ruleForm.forceDce">
                Emitir DC-E nas integrações (não buscar NF-e)
              </el-checkbox>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Contatos" name="contact">
            <el-form-item :label="$t('site')" prop="site">
              <el-input v-model="ruleForm.site" maxlength="155">
                <template slot="prepend">http://</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('nome-contato')" prop="contact">
              <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
                <el-input v-model="ruleForm.contact" maxlength="80"></el-input>
              </el-col>
            </el-form-item>
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('telefone-comercial')" prop="cep">
                  <el-input maxlength="16" v-model="ruleForm.phone.commercial" v-mask="'(##) ####-####'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('telefone-residencial')" prop="cep">
                  <el-input maxlength="16" v-model="ruleForm.phone.residential" v-mask="'(##) ####-####'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('telefone-celular')" prop="cep">
                  <el-input
                    maxlength="16"
                    v-model="ruleForm.phone.cellphone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="Licença" name="partner" v-if="ruleForm.customerType === '2'">
            <el-row :gutters="5">
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('taxa-de-marketing')" prop="royalties">
                  <el-input-number v-model="ruleForm.royalties" :controls="false" :precision="1" />
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('taxa-uso-plataforma')" prop="plataform">
                  <el-input-number v-model="ruleForm.plataform" :controls="false" :precision="1" />
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="2" :md="2" :lg="2" :xl="2">
                <el-form-item :label="$t('tipo')" prop="royaltiesType">
                  <el-select v-model="ruleForm.royaltiesType">
                    <el-option key="1" label="$" value="1" />
                    <el-option key="2" label="%" value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="role_access">
              <el-checkbox v-model="ruleForm.roleAccess">{{ $t("permite-acesso-papeis") }}</el-checkbox>
            </el-form-item>
            <el-form-item prop="payment">
              <el-checkbox v-model="ruleForm.payment">{{ $t("usar-meio-pagamento") }}</el-checkbox>
            </el-form-item>
            <el-form-item label="Métodos de pagamento" v-if="ruleForm.payment">
              <el-checkbox v-model="ruleForm.recipients.billet">{{ $t("boleto") }}</el-checkbox>
              <el-checkbox v-model="ruleForm.recipients.credit">{{ $t("cartao-credito") }}</el-checkbox>
              <el-checkbox v-model="ruleForm.recipients.debit">{{ $t("cartao-debito") }}</el-checkbox>
              <el-checkbox v-model="ruleForm.recipients.pix">{{ $t("pix") }}</el-checkbox>
            </el-form-item>
            <el-form-item prop="transfer" v-if="ruleForm.payment">
              <el-checkbox v-model="ruleForm.recipients.transfer_settings.transfer_enabled">{{
                $t("transferencia-automatica")
              }}</el-checkbox>
            </el-form-item>
            <el-form-item
              prop="transfer_interval"
              v-if="ruleForm.payment && ruleForm.recipients.transfer_settings.transfer_enabled"
            >
              <el-radio-group v-model="ruleForm.recipients.transfer_settings.transfer_interval">
                <el-radio label="Daily">Diário</el-radio>
                <el-radio label="Weekly">Semanal</el-radio>
                <el-radio label="Monthly">Mensal</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              prop="transfer_day"
              v-if="
                ruleForm.recipients.transfer_settings.transfer_enabled &&
                ruleForm.recipients.transfer_settings.transfer_interval === 'Weekly'
              "
            >
              <el-radio-group v-model="ruleForm.recipients.transfer_settings.transfer_day">
                <el-radio :label="1">Segunda-feira</el-radio>
                <el-radio :label="2">Terça-feira</el-radio>
                <el-radio :label="3">Quarta-feira</el-radio>
                <el-radio :label="4">Quinta-feira</el-radio>
                <el-radio :label="5">Sexta-feira</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="$t('dia-transferencia')"
              prop="transfer_day"
              v-if="
                ruleForm.recipients.transfer_settings.transfer_enabled &&
                ruleForm.recipients.transfer_settings.transfer_interval === 'Monthly'
              "
            >
              <el-input
                maxlength="2"
                v-model="ruleForm.recipients.transfer_settings.transfer_day"
                v-mask="'##'"
              ></el-input>
            </el-form-item>

            <el-form-item prop="antecipation" v-if="ruleForm.payment">
              <el-checkbox v-model="ruleForm.recipients.antecipation_settings.enabled">{{
                $t("antecipacao-automatica")
              }}</el-checkbox>
            </el-form-item>
            <el-form-item
              label="Modelo de antecipação"
              prop="type"
              v-if="ruleForm.payment && ruleForm.recipients.antecipation_settings.enabled"
            >
              <el-radio-group v-model="ruleForm.recipients.antecipation_settings.type">
                <el-radio label="full">Por volume</el-radio>
                <el-radio label="1025">Por D+X</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="Volume antecipável (%)"
              prop="volume_percentage"
              v-if="
                ruleForm.recipients.antecipation_settings.enabled &&
                ruleForm.recipients.antecipation_settings.type === 'full'
              "
            >
              <el-input
                maxlength="3"
                v-model="ruleForm.recipients.antecipation_settings.volume_percentage"
                v-mask="'###'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="Delay em dias"
              prop="delay"
              v-if="
                ruleForm.recipients.antecipation_settings.enabled &&
                ruleForm.recipients.antecipation_settings.type === '1025'
              "
            >
              <el-input
                maxlength="3"
                v-model="ruleForm.recipients.antecipation_settings.delay"
                v-mask="'###'"
              ></el-input>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Malha" name="malha">
            <CustomerMalha ref="tableMalha" />
          </el-tab-pane>
          <el-tab-pane label="Webhooks" name="webhook">
            <CustomerWebhooks ref="webhooks" />
          </el-tab-pane>
        </el-tabs>

        <el-form-item style="text-align: center">
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{
            $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{
            $t("atualizar")
          }}</el-button>
          <el-button type="danger" @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { ContractService } from "@/services/customers/contract.services";
import { CustomerService } from "@/services/customers/customers.services";
import { ServicesService } from "@/services/customers/services.services";
import { UserService } from "@/services/users/user.services";

import { i18n } from "@/plugin/i18n";
import { CnpjHelpers } from "@/xpost/helpers/cnpj";
import { CpfHelpers } from "@/xpost/helpers/cpf";
import ZipMixins from "../../../mixins/zipcode";
import MoneyMixins from "../../../mixins/money";

import PackageTableList from "@/xpost/views/financial/package/PackageTableList";
import FinancialTypeList from "@/xpost/views/financial/type/FinancialTypeList";
import BankList from "@/xpost/views/register/bank/BankList";
import ContractList from "@/xpost/views/register/contract/ContractList";
import CustomerList from "./CustomerList";
import CustomerTableServices from "./CustomerTableServices";
import CustomerMalha from "./CustomerMalha";
import CustomerTableAddress from "./components/CustomerTableAddress";
import CustomerLimit from "./components/CustomerLimit";
import CustomerWebhooks from "./CustomerWebhooks.vue";
export default {
  name: "CustomerAdd",
  mixins: [ZipMixins, MoneyMixins],
  components: {
    CustomerLimit,
    CustomerTableAddress,
    PackageTableList,
    ContractList,
    BankList,
    CustomerWebhooks,
    FinancialTypeList,
    CustomerList,
    CustomerMalha,
    CustomerTableServices,
  },
  data() {
    var checkFederalid = (rule, value, callback) => {
      if (value.length == 14) {
        CpfHelpers.checkCpf(rule, value, callback);
      } else if (value.length == 18) {
        CnpjHelpers.checkCnpj(rule, value, callback);
      }
      return callback();
    };
    return {
      dialogFormVisible: false,
      formCardPost: {
        cardpost: "",
        contract: "",
        type: 1,
        value: 0,
        principal: false,
      },
      user: {
        type: "2",
      },
      payment: {
        display: false,
        credit: false,
        pix: false,
        debit: false,
        billet: false,
      },
      daysValidateReverse: 90,
      maxInsurance: 0,
      federalidDuplicate: false,
      listServices: [],
      listContracts: [],
      listCardPost: [],
      addressList: [],
      id: "",
      contract: "",
      activeTab: "billet",
      ruleForm: {
        malha: {
          malha: false,
          send_all: false,
          discount_malha: 0,
          content: "",
          quantity: 1,
          value: 0,
        },
        useReserve: false,
        roleAccess: true,
        name: "",
        companyname: "",
        financialtype: "",
        federalidPayment: "",
        customerType: "1",
        plataform: 0,
        royalties: 0,
        royaltiesType: "1",
        federalid: "",
        cnpj: "",
        bank: "",
        limit: 0,
        insurance: 1,
        daysValidateReverse: 90,
        registermunicipal: "",
        registerstate: "",
        mail: "",
        cep: "",
        plp: false,
        whatsapp: false,
        unifiedLabel: false,
        forceDce: false,
        icms: false,
        day: 1,
        payment: false,
        discount: 0,
        contract: "",
        address: "",
        contact: "",
        city: "",
        state: "",
        headoffice: "",
        neighborhood: "",
        number: "",
        contractType: "1",
        packageTable: "",
        packageTableReverse: "",
        site: "",
        billetType: "1",
        billetValue: 0,
        valueType: "1",
        billetExclusive: false,
        calculatePricetable: true,
        extent: "",
        recipients: {
          billet: true,
          credit: true,
          pix: true,
          debit: true,
          antecipation_settings: {
            enabled: false,
            type: "full",
            volume_percentage: 100,
            delay: 365,
          },
          transfer_settings: {
            transfer_enabled: false,
            transfer_interval: "Weekly",
            transfer_day: 1,
          },
        },
        phone: {
          commercial: "",
          residential: "",
          cellphone: "",
          billetExclusive: false,
        },
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-fantasia-obrigatorio"),
            trigger: "blur",
          },
        ],
        companyname: [
          {
            required: true,
            message: i18n.tc("razao-social-obrigatorio"),
            trigger: "blur",
          },
        ],
        federalid: {
          validator: checkFederalid,
          trigger: "blur",
        },
      },
    };
  },
  watch: {
    "ruleForm.federalid"() {
      this.federalidDuplicate = false;
    },
  },
  methods: {
    checkFederalidDuplicate() {
      const vm = this;
      vm.federalidDuplicate = false;
      const value = vm.ruleForm.federalid || "";
      if (value.length !== 14 && value.length !== 18) return;
      CustomerService.findByFederalId(value.replace(/[^a-zA-Z0-9]/g, ""))
        .then((record) => {
          if (record && record.id !== vm.id) {
            vm.federalidDuplicate = true;
          }
        })
        .catch(() => {});
    },
    manager() {
      console.log("this.$refs", this.$refs, this.$refs.limit);
      this.$refs.limit.open();
    },
    back() {
      var vm = this;
      vm.$router.replace({ name: "customer" });
    },
    addressAdd(data) {
      this.addressList.push(data);
    },
    addressUpdate(updatedAddress) {
      // procura pelo type do endereço
      const index = this.addressList.findIndex((x) => x.type === updatedAddress.type);
      if (index > -1) {
        // substitui o endereço existente do mesmo tipo
        this.addressList.splice(index, 1, updatedAddress);
      } else {
        // se não encontrar, adiciona
        this.addressList.push(updatedAddress);
      }
    },
    saveLimit(newLimit) {
      console.log("newLimit", newLimit);
      this.ruleForm.limit = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(newLimit);
    },
    delCardPost(code)  {
      const index = this.listCardPost.findIndex((x) => x.cardpost.code === code);
      if (index > -1) {
        this.listCardPost.splice(index, 1);
      }
    },
    fetchRecords() {
      const vm = this;
      ServicesService.actives()
        .then((response) => {
          vm.listServices = response.records;
          if (vm.id) {
            vm.get();
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.get(vm.id)
        .then((response) => {
          vm.ruleForm.name = response.name;
          vm.ruleForm.companyname = response.companyname;
          vm.ruleForm.federalid = response.federalid;
          vm.ruleForm.federalidPayment = response.federalid;
          vm.ruleForm.registermunicipal = response.registermunicipal;
          vm.ruleForm.registerstate = response.registerstate;
          vm.ruleForm.mail - response.mail;
          vm.ruleForm.phone.commercial = response.phoneCommercial;
          vm.ruleForm.royalties = response.royalties;
          vm.ruleForm.plataform = response.plataform;
          vm.ruleForm.royaltiesType = response.royaltiesType;
          vm.ruleForm.customerType = response.customerType;
          vm.ruleForm.contact = response.contact;
          vm.ruleForm.roleAccess = response.roleAccess;
          vm.ruleForm.phone.cellphone = response.phoneCellphone;
          vm.ruleForm.city = response.city || response.zipcode.city;
          vm.ruleForm.address = response.address || response.zipcode.address;
          vm.ruleForm.extent = response.extent;
          vm.ruleForm.limit = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
          }).format(response.limit);
          vm.ruleForm.neighborhood = response.neighborhood || response.zipcode.neighborhood;
          vm.ruleForm.number = response.number;
          vm.ruleForm.plp = response.plp;
          vm.ruleForm.whatsapp = response.whatsapp || false;
          vm.ruleForm.unifiedLabel = response.unifiedLabel === true;
          vm.ruleForm.forceDce = response.forceDce === true;
          vm.ruleForm.icms = response.icms || false;
          vm.ruleForm.discount = response.discount;
          vm.ruleForm.insurance = response.insurance;
          vm.ruleForm.daysValidateReverse = +response.daysValidateReverse;
          vm.maxInsurance = +response.maxInsurance;
          if (response.insurance && +response.insurance > 0) vm.insurance = false;
          vm.ruleForm.billetExclusive = response.billetExclusive;
          vm.ruleForm.calculatePricetable = response.calculatePricetable;
          vm.ruleForm.cep = response.zipcode.zipcode;
          vm.ruleForm.state = response.state || response.zipcode.state;
          vm.ruleForm.packageTable = response.packagetable ? response.packagetable.id : "";
          //          vm.ruleForm.contract = response.contract.id;
          vm.ruleForm.packageTableReverse = response.packagetableReverse ? response.packagetableReverse.id : "";
          vm.ruleForm.mail = response.mail;
          vm.ruleForm.day = response.day;
          vm.ruleForm.useReserve = response.useReserve;
          vm.ruleForm.bank = response.bank.id;
          vm.ruleForm.headoffice = response.headoffice ? response.headoffice.id : "";
          vm.ruleForm.financialtype = response.financialtype.id;
          vm.listCardPost = response.cardpost;
          vm.ruleForm.site = response.site;
          vm.addressList = response.addressList || [];
          vm.$refs.tableServices.selected(response.service);
          vm.$refs.tableMalha.setup(response);
          vm.$refs.webhooks.setup(response);

          if (response.customerType === "1" && response.partner) {
            vm.payment.display = response.partner.payment;
            vm.payment.billet = response.partner.payment_settings.billet;
            vm.payment.credit = response.partner.payment_settings.credit;
            vm.payment.debit = response.partner.payment_settings.debit;
            vm.payment.pix = response.partner.payment_settings.pix;

            if (response.payment) {
              vm.ruleForm.payment = response.payment;
              vm.ruleForm.recipients.billet = response.payment_settings.billet;
              vm.ruleForm.recipients.credit = response.payment_settings.credit;
              vm.ruleForm.recipients.debit = response.payment_settings.debit;
              vm.ruleForm.recipients.pix = response.payment_settings.pix;
            }
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    validate() {
      const vm = this;
      const group = {};
      for (const row of vm.$refs.tableServices.selection) {
        // Agrupa pelo CÓDIGO do grupo: grupos distintos podem exibir o mesmo nome
        const name = row.servicegroupCode || (row.servicegroup && row.servicegroup.code) || row.servicegroup || "Não definido";
        if (group[name]) {
          return false;
        }
        group[name] = true;
      }
      return false;
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (vm.$refs.tableServices.validate()) {
          return this.$message({
            type: "error",
            message: "Você não pode relacionar dois serviços do mesmo grupo para o cliente!",
            duration: 5000,
          });
        }
        const malha = vm.$refs.tableMalha.validate();
        if (malha) {
          return this.$message({
            type: "error",
            message: malha,
            duration: 5000,
          });
        }
        const webhooks = vm.$refs.webhooks.validate();

        if (valid) {
          for (const record of vm.listCardPost) {
            delete record.cardpost.contract;
          }

          const addressData = vm.addressList.find((x) => x.type == "main");
          if (!addressData) {
            return this.$message({
              type: "error",
              message: "É preciso informar um endereço principal",
              duration: 5000,
            });
          }

          vm.ruleForm.cep = addressData.zipcode;
          vm.ruleForm.city = addressData.city;
          vm.ruleForm.address = addressData.address;
          vm.ruleForm.neighborhood = addressData.neighborhood;
          vm.ruleForm.state = addressData.state;
          vm.ruleForm.number = addressData.number;
          vm.ruleForm.extent = addressData.extent;
          vm.ruleForm.recipients.transfer_settings.transfer_day =
            +vm.ruleForm.recipients.transfer_settings.transfer_day;

          const formMalha = vm.$refs.tableMalha.get();
          vm.ruleForm.malha = formMalha;
          const formWebhooks = vm.$refs.webhooks.get();
          vm.ruleForm.webhooks = formWebhooks;

          const selectedServices = vm.$refs.tableServices.get();
          const allServicesWithCustomData = vm.$refs.tableServices.getAllServicesWithCustomData();
          selectedServices.forEach((service) => {
            const customData = allServicesWithCustomData.find((item) => item.id === service.id);
            if (customData) {
              service.customMalha = customData.customMalha;
              service.customSpread = customData.customSpread;
            }
          });

          const loading = vm.$loading(vm.$options.loading);
          CustomerService.add(
            vm.ruleForm,
            selectedServices,
            vm.listCardPost,
            vm.addressList
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("cliente-adicionado-sucesso"),
                duration: 5000,
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
                duration: 5000,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.$refs.tableServices.validate()) {
            return this.$message({
              type: "error",
              message: "Você não pode relacionar dois serviços do mesmo grupo para o cliente!",
              duration: 5000,
            });
          }
          const malha = vm.$refs.tableMalha.validate();
          if (malha) {
            return this.$message({
              type: "error",
              message: malha,
              duration: 5000,
            });
          }
          const loading = vm.$loading(vm.$options.loading);
          for (const row of vm.listCardPost) {
            delete row.cardpost.contract;
          }

          const formMalha = vm.$refs.tableMalha.get();
          vm.ruleForm.malha = formMalha;
          const formWebhooks = vm.$refs.webhooks.get();
          console.log('formWebhooks', formWebhooks)
          vm.ruleForm.webhooks = formWebhooks;

          // Obter serviços selecionados (para validação de grupos)
          const selectedServices = vm.$refs.tableServices.get();

          // Adicionar informações de customMalha para todos os serviços
          const allServicesWithCustomData = vm.$refs.tableServices.getAllServicesWithCustomData();
          selectedServices.forEach((service) => {
            const customData = allServicesWithCustomData.find((item) => item.id === service.id);
            if (customData) {
              service.customMalha = customData.customMalha;
              service.customSpread = customData.customSpread;
            }
          });

          CustomerService.update(vm.id, vm.ruleForm, selectedServices, vm.listCardPost, vm.addressList)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("cliente-atualizado-sucesso"),
                duration: 5000,
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
                duration: 5000,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addpost() {
      const vm = this;
      vm.formCardPost.cardpost = "";
      //      vm.formCardPost.contract = "";
      vm.formCardPost.value = 0;
      vm.formCardPost.type = 1;
      vm.dialogFormVisible = true;
    },
    addressRemove(zipcodeToRemove) {
      this.addressList = this.addressList.filter((addr) => addr.zipcode !== zipcodeToRemove);
    },
    addCardPost() {
      const vm = this;

      const save = function () {
        vm.dialogFormVisible = false;
        const contract = vm.listContracts.find((x) => x.id === vm.formCardPost.contract);
        const cardpost = contract.cardpost.find((x) => x.id === vm.formCardPost.cardpost);

        const data = {
          cardpost: cardpost,
          type: vm.formCardPost.type,
          value: vm.formCardPost.value,
          principal: vm.formCardPost.principal,
        };
        data.cardpost.contract = contract;

        vm.listCardPost.push(data);
      };

      if (vm.formCardPost.principal) {
        const p = vm.listCardPost.find((x) => x.principal == true);
        if (p) {
          this.$confirm("Já existe outro cartão como principal, deseja trocar?", "Aviso", {
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            type: "warning",
          })
            .then(() => {
              for (let record of vm.listCardPost) {
                record.principal = false;
              }

              save();
            })
            .catch(() => {
              return false;
            });
        } else {
          save();
        }
      } else {
        save();
      }
    },
    fetchContracts() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ContractService.list()
        .then((response) => {
          vm.listContracts = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      if (row[property]) {
        return row[property] === value;
      } else {
        return value === "Não definido";
      }
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((user) => {
        vm.user = user;
        vm.fetchRecords();
        vm.fetchContracts();
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
        } else {
          vm.$refs.name.$el.children[0].focus();
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  computed: {
    filterGroup() {
      const vm = this;
      const list = [];
      for (const row of vm.listServices) {
        const group = row.servicegroup || "Não definido";
        if (!list.find((x) => x.value === group)) {
          list.push({
            text: group,
            value: group,
          });
        }
      }
      return list;
    },
    contracts() {
      const vm = this;
      const record = vm.listContracts.find((x) => x.id === vm.formCardPost.contract);
      if (record) {
        return record.cardpost;
      }
      return [];
    },
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

/* mesma posição da mensagem de validação (el-form-item__error), em amarelo */
.federalid-duplicate {
  position: absolute;
  top: 100%;
  left: 0;
  color: #e6a23c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
